import type { ReactElement } from 'react';

import type { CampaignName } from 'src/common/enums/campaigns';

import type { UserData } from '../user';

export enum CampaignLifecycleType {
  TIME_BASED = 'TIME_BASED',
  TIME_AND_SESSION_BASED = 'TIME_AND_SESSION_BASED',
}

export interface CampaignDTO {
  name: CampaignName;
  lifecycleType: CampaignLifecycleType;
  amount: number;
  startDate: string;
  endDate?: string;
  sessionExpiration?: number;
}

export interface Campaign extends Omit<CampaignDTO, 'startDate' | 'endDate'> {
  startTime: number;
  endTime?: number;
}

export interface CampaignComponentProps {
  name: CampaignName;
}

export interface CampaignConfig {
  pathsToExclude?: string[];
  pathsToInclude?: string[];
  renderComponent: () => ReactElement;
  shouldShow?: (path: string, user?: UserData) => boolean;
}

export enum CampaignElementType {
  TOP_BAR = 'TOP_BAR',
  EMBEDDED_BAR = 'EMBEDDED_BAR',
  MODAL = 'MODAL',
  ACCOUNT_CARD = 'ACCOUNT_CARD',
}

export interface CampaignStorage {
  activeCampaign: ActiveCampaign | null;
  seenCampaigns: SeenCampaign[];
}

export interface NotApplicableCampaignStorage {
  campaignName: CampaignName;
  campaignFriendlyName: string;
}

export interface ActiveCampaign {
  name: CampaignName;
  sessionExpiration: number;
}

export interface SeenCampaign {
  name: CampaignName;
  endTime?: number;
}
